import { render, staticRenderFns } from "./TwMenuButton.vue?vue&type=template&id=517d5205&"
import script from "./TwMenuButton.vue?vue&type=script&lang=js&"
export * from "./TwMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports